/**
 * String parsing utilities
 * Pure functions for parsing and converting strings
 */

/**
 * Parse string to boolean
 * @param value - String to parse
 * @returns Boolean value or undefined if invalid
 * @example parseBoolean("true") => true
 * @example parseBoolean("1") => true
 */
export function parseBoolean(value: string | null): boolean | undefined {
    if (!value) return undefined;
    return value === "true" || value === "1";
}

/**
 * Get string value or undefined
 * @param value - String value or null
 * @returns String or undefined
 */
export function parseString(value: string | null): string | undefined {
    return value ?? undefined;
}
